module.exports = __webpack_public_path__ + "h5/img/record2.e57336ff.png";